import axios from 'axios';

const API_BASE =
  process.env.REACT_APP_API_BASE ||
  (window.location.port === '3000' ? 'http://localhost:3001' : '');

export async function fetchAteSwVersions() {
  const response = await axios.get(`${API_BASE}/api/ate-sw-versions`);
  return response.data.map((version) => ({
    value: version.AteSwVersion,
    label: version.AteSwVersion,
  }));
}

export async function fetchSerialNumbers() {
  const response = await axios.get(`${API_BASE}/api/distinct-serial-numbers`);
  return response.data.map((serialNumber) => ({
    value: serialNumber,
    label: serialNumber,
  }));
}

export async function fetchTestspecs() {
  const response = await axios.get(`${API_BASE}/api/testspecs`);
  return response.data.map((testspec) => ({
    value: testspec.Testspec,
    label: testspec.Testspec,
  }));
}

export async function fetchParetoData({ startDate, endDate, ateSwVersion, selectedSerialNumbers, selectedTestspec, selectedFamilies = [] }) {
  const response = await axios.get(`${API_BASE}/api/pareto-failure-analysis`, {
    params: {
      startDate: startDate ? startDate.toISOString().split('T')[0] : null,
      endDate: endDate ? endDate.toISOString().split('T')[0] : null,
      ateSwVersion: ateSwVersion || null,
      Testspec: selectedTestspec || null,
      serialNumbers: selectedSerialNumbers.map((serialNumber) => serialNumber.value).join(','),
      selectedFamilies: selectedFamilies.join(',') || undefined,
    },
  });
  return response.data;
}
